import { useEffect, useState } from "react";
import AproveDisaproveActionView from "./AproveDisaproveActionView/AproveDisaproveActionBtnView";
import { useSingleSpendingDemand, useSpendingDemandSpendingList } from "../../../hooks";
import SuccessMessage, { SuccessMessageType } from "../../../../../components/atoms/SuccessMessage/SuccessMessage";
import { useParams } from "react-router-dom";
import useUserAuth from "../../../../auth/hook/useUserAuth";

const AproveDisaproveActionBtnPresenter = () => {
  const { spendingDemandId } = useParams();
  const { isComptable, isSuperviseurTechnique } = useUserAuth();
  const {
    sendAskForUpdateSpendingDemand,
    sendValidateSpendingDemand,
    sendRefuseSpendingDemand,
    singleSpendingDemandData,
  } = useSingleSpendingDemand();

  const spendingList = useSpendingDemandSpendingList(spendingDemandId || "", {
    disableQuery: singleSpendingDemandData?.spending_demand_status !== "VALIDATE",
  });

  const [remarks, setRemarks] = useState("");
  const [successMessage, setSuccessMessage] = useState<{
    type: SuccessMessageType;
    isVisible: boolean;
  }>({
    type: 'validation',
    isVisible: false,
  });

  useEffect(() => {
    if (sendValidateSpendingDemand.isSucess) {
      setRemarks("");
      setSuccessMessage({
        type: 'validation',
        isVisible: true,
      });
      
      // Hide the message after 3 seconds
      const timer = setTimeout(() => {
        setSuccessMessage(prev => ({ ...prev, isVisible: false }));
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [sendValidateSpendingDemand.isSucess]);

  useEffect(() => {
    if (sendRefuseSpendingDemand.isSucess) {
      setRemarks("");
      setSuccessMessage({
        type: 'refus',
        isVisible: true,
      });
      
      // Hide the message after 3 seconds
      const timer = setTimeout(() => {
        setSuccessMessage(prev => ({ ...prev, isVisible: false }));
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [sendRefuseSpendingDemand.isSucess]);

  useEffect(() => {
    if (sendAskForUpdateSpendingDemand.isSucess) {
      setRemarks("");
      setSuccessMessage({
        type: 'demande_correction',
        isVisible: true,
      });
      
      // Hide the message after 3 seconds
      const timer = setTimeout(() => {
        setSuccessMessage(prev => ({ ...prev, isVisible: false }));
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [sendAskForUpdateSpendingDemand.isSucess]);
  if (!singleSpendingDemandData) {
    return <></>;
  }
  const isToProcess = singleSpendingDemandData.is_to_process;

  // Show success message if visible
  if (successMessage.isVisible) {
    return (
      <SuccessMessage 
        type={successMessage.type} 
        isVisible={successMessage.isVisible} 
      />
    );
  }

  if (
    sendAskForUpdateSpendingDemand.isPending ||
    sendValidateSpendingDemand.isPending ||
    sendRefuseSpendingDemand.isPending
  ) {
    return <p>Envoi en cours... </p>;
  }

  if (singleSpendingDemandData?.spending_demand_status === "CANCELLED") {
    return <></>
  }

  if (singleSpendingDemandData?.spending_demand_status === "VALIDATE") {
    const hasNoSpendings = spendingList.getAllQuery.data?.data?.length === 0;
    const isLoadingSpendings = spendingList.getAllQuery.isLoading;

    if (isLoadingSpendings) {
      return <></>;
    }

    if (hasNoSpendings) {
      return (
        <div>
          <AproveDisaproveActionView
            refuseBtn={{
              onClick: () => {
                sendRefuseSpendingDemand.run({ message: remarks });
              },
              disable: sendRefuseSpendingDemand.isPending,
            }}
            setRemaks={setRemarks}
            remaksValue={remarks}
          />
        </div>
      );
    }

    return <></>;
  }

  if (singleSpendingDemandData?.spending_demand_status === "REFUSED"
    || singleSpendingDemandData?.spending_demand_status === "CLOSED"
    || singleSpendingDemandData?.spending_demand_status === "CREDITED"
    || singleSpendingDemandData?.spending_demand_status === "PAYED"

  ) {
    return <></>
  }
  const isBox = singleSpendingDemandData.spending_demand_type === "BOX";
  const isSupervisorActing = isSuperviseurTechnique && isBox;

  if (isToProcess || isSupervisorActing) {
    // Le bouton « Valider » est piloté par l'autorisation réelle calculée côté backend
    // (can_validate) : un comptable qui est AUSSI manager du projet peut valider, alors
    // qu'un comptable « pur » ne le peut pas (les deux ont is_to_process = true via la
    // visibilité). Fallback sur l'ancienne heuristique si le backend ne renvoie pas
    // encore le flag (déploiement progressif).
    const isRestrictedType = singleSpendingDemandData.spending_demand_type === "PROJECT" || singleSpendingDemandData.spending_demand_type === "BOX";
    const hideApproveBtn = singleSpendingDemandData.can_validate !== undefined
      ? !singleSpendingDemandData.can_validate
      : (isComptable && isRestrictedType && !isSupervisorActing);

    return (
      <div>
        <AproveDisaproveActionView
          approveBtn={hideApproveBtn ? undefined : {
            onClick: () => {
              sendValidateSpendingDemand.run({ message: remarks });
            },
            disable: sendValidateSpendingDemand.isPending,
          }}
          refuseBtn={{
            onClick: () => {
              sendRefuseSpendingDemand.run({ message: remarks });
            },
            disable: sendRefuseSpendingDemand.isPending,
          }}
          askForUpdateBtn={{
            onClick: () => {
              sendAskForUpdateSpendingDemand.run({ message: remarks });
            },
            disable: sendAskForUpdateSpendingDemand.isPending,
          }}
          setRemaks={setRemarks}
          remaksValue={remarks}
        />
      </div>
    );
  }
  return <></>;
};

export default AproveDisaproveActionBtnPresenter;
